///<amd-module name="typeahead/core/message/FormLoadedMessage" />
/// <reference path="../../../typings/typeahead/plugins.d.ts" />
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class FormLoadedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.form_loaded";
    }

    constructor(private tab: string) {}

    public getTopic(): string {
        return FormLoadedMessage.getTopic();
    }

    public getTab(): string {
        return this.tab;
    }
}
